import provincia from "@/locales/languages/es_MX/view/geograficos/provincia";
import localidad from "@/locales/languages/es_MX/view/geograficos/localidad";
import pais from "@/locales/languages/es_MX/view/geograficos/pais"
import lada from "@/locales/languages/es_MX/view/geograficos/lada"

export default {
  provincia
  , localidad
  , pais
  , lada
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/geograficos/index.js